import { render, staticRenderFns } from "./AsideCore.vue?vue&type=template&id=64761586&scoped=true"
import script from "./AsideCore.vue?vue&type=script&lang=js"
export * from "./AsideCore.vue?vue&type=script&lang=js"
import style0 from "./AsideCore.vue?vue&type=style&index=0&id=64761586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64761586",
  null
  
)

export default component.exports